import { Box } from "@mui/material"
import type { BoxProps, SxProps, Theme } from "@mui/material"
import { CloudUploadOutlined } from "@mui/icons-material"

export interface DropTargetProps extends BoxProps {
  isActive?: boolean
}

const DROP_TARGET_SX = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
  boxSizing: "border-box",
  width: "100%",
  height: "100%",
  p: 3,
  textAlign: "center",
  color: "text.secondary",
  bgcolor: "background.paper",
  border: 2,
  borderStyle: "dashed",
  borderColor: "divider",
  borderRadius: 2,
} satisfies SxProps<Theme>

const ACTIVE_SX = {
  color: "primary.main",
  bgcolor: "action.hover",
  borderColor: "primary.main",
} satisfies SxProps<Theme>

export function DropTarget({ isActive = false, sx, children, ...boxProps }: DropTargetProps) {
  return (
    <Box {...boxProps} sx={[DROP_TARGET_SX, isActive && ACTIVE_SX, ...(Array.isArray(sx) ? sx : [sx])]}>
      <CloudUploadOutlined fontSize="large" aria-hidden />
      {children}
    </Box>
  )
}
